/* PIKOVA — the plans.

   One job: open and close the rhythm of billing under a card. Everything else
   is done by things that already exist — the radio inputs carry the chosen
   term, the form posts it, and Dawn's <product-form> does the fetch and opens
   the cart drawer. There is no cart code here, and there should never be. */

(function () {
  'use strict';

  function close(card) {
    var button = card.querySelector('[data-pk-begin]');
    var panel = card.querySelector('[data-pk-rhythm]');
    if (!button || !panel) return;
    panel.hidden = true;
    card.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    if (button.dataset.labelClosed) button.textContent = button.dataset.labelClosed;
  }

  function open(card) {
    var button = card.querySelector('[data-pk-begin]');
    var panel = card.querySelector('[data-pk-rhythm]');
    if (!button || !panel) return;
    panel.hidden = false;
    card.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    if (button.dataset.labelOpen) button.textContent = button.dataset.labelOpen;

    // move to the term the visitor is most likely to want to read first
    var checked = panel.querySelector('input[data-pk-term-input]:checked');
    if (checked) checked.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-pk-begin]');
    if (!button) return;

    var card = button.closest('[data-pk-plan]');
    if (!card) return;

    var isOpen = card.classList.contains('is-open');

    // only one card is open at a time; three sets of prices at once is a
    // comparison table, and this is meant to be a choice
    var section = card.closest('.pk-plans');
    if (section) {
      section.querySelectorAll('[data-pk-plan].is-open').forEach(function (other) {
        if (other !== card) close(other);
      });
    }

    if (isOpen) close(card);
    else open(card);
  });

  // Escape closes the open card, as it does everywhere else in the theme
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open_card = document.querySelector('[data-pk-plan].is-open');
    if (!open_card) return;
    close(open_card);
    var button = open_card.querySelector('[data-pk-begin]');
    if (button) button.focus();
  });
})();
